import { MinusCircleOutlined } from "@ant-design/icons";
import { PermissionRequest } from "@p0security/shared/types/permission";
import { Button, Typography } from "antd";
import { GraphTooltip } from "components/GraphTooltip";
import { format, formatDistance } from "date-fns";
import { FirestoreDoc } from "providers/FirestoreProvider";

export const ActiveRequestActions = (
  request: FirestoreDoc<PermissionRequest>,
  onRevoke: () => void,
  processing: boolean
) => {
  const Info = request.data.expiryTimestamp ? (
    <GraphTooltip
      key="expiry"
      title={format(request.data.expiryTimestamp, "PPpp")}
    >
      <Typography.Text type="secondary">
        Expires in {formatDistance(request.data.expiryTimestamp, Date.now())}
      </Typography.Text>
    </GraphTooltip>
  ) : null;

  const RevokeButton = (
    <GraphTooltip
      key="revoke"
      title={
        request.data.status !== "DONE_NOTIFIED"
          ? "Request is currently being processed and cannot be revoked."
          : "Revoke grant from user"
      }
    >
      <Button
        key="revoke"
        type="default"
        onClick={onRevoke}
        loading={processing}
        disabled={request.data.status !== "DONE_NOTIFIED"}
      >
        <MinusCircleOutlined /> Revoke
      </Button>
    </GraphTooltip>
  );
  return [Info, RevokeButton];
};
